// src/utils/referrals.js

const REF_KEY = "satstacker_ref";

export function captureReferralFromSearch(search) {
  try {
    const p = new URLSearchParams(search || window.location.search);
    const ref = p.get("ref") || p.get("referral") || p.get("ref_code");

    if (ref && String(ref).trim()) {
      localStorage.setItem(REF_KEY, String(ref).trim().slice(0, 32));
      return String(ref).trim().slice(0, 32);
    }
  } catch {}

  return null;
}

export function getStoredReferralCode() {
  try {
    return localStorage.getItem(REF_KEY) || null;
  } catch {
    return null;
  }
}

export function clearStoredReferralCode() {
  try {
    localStorage.removeItem(REF_KEY);
  } catch {}
}